@if (
  contentfulRelatedArticlesContent.length > 0 &&
  contentfulRelatedArticlesContent[0].relatedArticles &&
  contentfulRelatedArticlesContent[0].relatedArticles.length > 0
) {
  <div class="container-fluid related-articles">
    <div class="row mt-4 justify-content-center related-articles-wrapper">
      <h2 i18n="@@contentful.relatedArticles" class="text-center related-articles-title text-uppercase">
        <span>Related articles</span>
      </h2>
      <app-contentful-articles-list [contentfulArticlesListContent]="contentfulRelatedArticlesContent" />
    </div>
  </div>
}
